<div style="width: 25px;height: 25px;float: right;position: relative;right: -10px;cursor: pointer;"
     (click)="closeModal()">
    <i class="material-icons icon" style="font-size: 30px;color: #c80000">
        cancel
    </i>
</div>
<mat-dialog-content>

    <form [formGroup]="absenceForm">

        <div *ngIf="data.isNew && data.tabNo != 5">
            <div class="row" *ngIf="currentUser.hr">
                <div class="col-lg-12">
                    <div class="form-group">
                        <label class="radio-group-label" id="isParentExist">Başkası adına mı kayıt oluşturulacak?</label>
                        <mat-radio-group class="horizontal-radio-group" aria-labelledby="isParentExist"
                                         [(ngModel)]="isAbsenceForMe" [ngModelOptions]="{standalone: true}"
                        (change)="absenceOwnerChange()">
                            <mat-radio-button class="absenceforme-radio-button" value="1">Evet</mat-radio-button>
                            <mat-radio-button class="absenceforme-radio-button" value="0" [checked]="true" >Hayır</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="isAbsenceForMe == '1'">
                <div class="col-lg-12">
                    <!-- kimin adina acilacak ise onu sec -->
                    <div class="form-group">
                        <mat-form-field class="absence-form-field">
                            <input type="text" placeholder="İzin açılacak çalışan seçiniz" aria-label="Number"
                                   matInput [formControl]="employeeControl" [matAutocomplete]="auto">
                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn2">
                                <!--<mat-option *ngFor="let employee of filteredEmployeeList | async" (onSelectionChange)="employeeChange($event)">-->
                                <mat-option *ngFor="let employee of filteredEmployeeList | async" [value]="employee">
                                    {{employee.fullName}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="data.tabNo == 5">
            <label class="radio-group-label"></label>
            <mat-radio-group class="horizontal-radio-group" [(ngModel)]="isCompleted" [ngModelOptions]="{standalone: true}">
                <mat-radio-button name="approve" class="absenceforme-radio-button" [value]="radioOnay">Onayla</mat-radio-button>
                <mat-radio-button name="reject" class="absenceforme-radio-button" [value]="radioRed">Reddet</mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="absence-form-field">
                        <input  matInput placeholder="Personel Ad Soyadı" style="width: 250px;"
                            [value]="personelFullname" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="absence-form-field">
                        <input matInput placeholder="Departman" style="width: 250px;"
                            [value]="departmentName" readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="form-group">
            <mat-form-field class="absence-form-field">
                <mat-label>İzin Türü Seçiniz</mat-label>
                <mat-select [(value)]="selectedAbsenceType" formControlName="absenceType" (selectionChange)="absenceTypeChanged()">
                    <mat-option *ngFor="let absenceType of absenceTypeList" [value]="absenceType" >
                        {{absenceType.description}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="absenceForm.controls['absenceType'].hasError('required')">İzin Türü Seçiniz
                </mat-error>
            </mat-form-field>
        </div>

        <div class="form-group" *ngIf="isAbsenceExcuseSelected || data.absenceTypeId == 22">
            <mat-form-field class="absence-form-field">
                <mat-label>İzin Gerekçesi Seçiniz</mat-label>
                <mat-select formControlName="absenceExcuseReason">
                    <mat-option *ngFor="let absenceExcuseReason of absenceExcuseReasons" [value]="absenceExcuseReason">
                        {{absenceExcuseReason.description}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="absenceForm.controls['absenceExcuseReason'].hasError('required')">İzin Gerekçesi Seçiniz
                </mat-error>
            </mat-form-field>
        </div>

        <div class="form-group" *ngIf="isAbsenceDeservedExist">
            <div class="row">
                <mat-form-field class="col-lg-4">
                    <input matInput placeholder="Hak edilen" readonly [value]="absenceDeservedResponse.deservedAmount">
                </mat-form-field>
                <mat-form-field class="col-lg-4">
                    <input matInput placeholder="Kullanılan" readonly [value]="absenceDeservedResponse.totalUsedAbsenceAmount">
                </mat-form-field>
                <mat-form-field class="col-lg-4">
                    <input matInput placeholder="Kalan" readonly [value]="absenceDeservedResponse.remainingAmount - absenceDeservedResponse.totalUsedAbsenceAmount">
                </mat-form-field>
            </div>
        </div>

        <!--<div class="row" *ngIf="selectedAbsenceType != null && selectedAbsenceType.id == 22"> --> <!-- Mazaret izni seçildiği zaman -->
        <div class="row" *ngIf="selectedAbsenceType != null">
                <div class="col-lg-6">
                    <div class="form-group">
                        <mat-form-field class="w-100">
                            <mat-label>Başlangıç Tarihi</mat-label>
                            <input readonly matInput [matDatepicker]="pickerStart" formControlName="absenceStartDate"
                                   placeholder="Başlangıç Tarihi" (dateChange)="startDateChanged()">
                            <mat-datepicker-toggle disabled="false" matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                            <mat-datepicker #pickerStart></mat-datepicker>
                        </mat-form-field>
                        <mat-error *ngIf="absenceForm.controls['absenceStartDate'].hasError('required') && absenceForm.get('absenceStartDate').touched">
                            Başlangıç tarihi seçiniz
                        </mat-error>
                    </div>
                </div>

                <div class="col-lg-3">
                    <div class="form-group">
                        <mat-form-field class="w-100">
                            <mat-label>Saat seçiniz</mat-label>
                            <mat-select [(value)]="selectedHourMinuteForStart" (selectionChange)="startHourMinuteChanged()">
                                <mat-option *ngFor="let hourMinute of hourMinuteList" [value]="hourMinute">
                                    {{hourMinute}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
        </div>
        <div class="row" *ngIf="selectedAbsenceType != null">
                <div class="col-lg-6">
                    <div class="form-group">
                        <mat-form-field class="w-100">
                            <mat-label>Bitiş Tarihi</mat-label>
                            <input readonly matInput [matDatepicker]="pickerEnd" formControlName="absenceEndDate"
                                   placeholder="Bitiş Tarihi" (dateChange)="endDateChanged()">
                            <mat-datepicker-toggle disabled="false" matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                            <mat-datepicker #pickerEnd></mat-datepicker>
                        </mat-form-field>
                        <mat-error *ngIf="absenceForm.controls['absenceEndDate'].hasError('required') && absenceForm.get('absenceEndDate').touched">Bitiş tarihi
                            seçiniz</mat-error>
                        <mat-error *ngIf="absenceForm.controls['absenceEndDate'].hasError('notEquivalent')">
                            Başlangıç tarihi bitiş tarihinden  büyük olamaz.
                        </mat-error>
                    </div>
                </div>

                <div class="col-lg-3">
                    <div class="form-group">
                        <mat-form-field class="w-100">
                            <mat-label>Saat seçiniz</mat-label>
                            <mat-select [(value)]="selectedHourMinuteForEnd" (selectionChange)="endHourMinuteChanged()">
                                <mat-option *ngFor="let hourMinute of hourMinuteList" [value]="hourMinute">
                                    {{hourMinute}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
        </div>

        <!--<div class="row" *ngIf="selectedAbsenceType != null && selectedAbsenceType.id != 22">
                <div class="col-lg-6" >

                    <div class="form-group" *ngIf="selectedAbsenceType != null">
                        <mat-form-field class="w-100">
                            <input readonly matInput [ngxMatDatetimePicker]="pickerStart" placeholder="Başlangıç Tarihi" formControlName="absenceStartDate" (dateChange)="startDateChanged()">
                            <mat-datepicker-toggle disabled="false" matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                            <ngx-mat-datetime-picker (opened)="setReadonlyToHourAndMinute()" [stepMinute]="30" [showSeconds]="false" #pickerStart ></ngx-mat-datetime-picker>
                        </mat-form-field>
                        <mat-error *ngIf="absenceForm.controls['absenceStartDate'].hasError('required') && absenceForm.get('absenceStartDate').touched">Başlangıç tarihi
                            seçiniz</mat-error>
                    </div>
                </div>
                <div class="col-lg-6" >
                    <div class="form-group" *ngIf="selectedAbsenceType != null">
                        <mat-form-field class="w-100">
                            <input readonly matInput [ngxMatDatetimePicker]="pickerEnd" placeholder="Bitiş Tarihi" formControlName="absenceEndDate" (dateChange)="endDateChanged()">
                            <mat-datepicker-toggle disabled="false" matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                            <ngx-mat-datetime-picker (opened)="setReadonlyToHourAndMinute()" [stepMinute]="30" [showSeconds]="false" #pickerEnd></ngx-mat-datetime-picker>
                        </mat-form-field>
                        <mat-error *ngIf="absenceForm.controls['absenceEndDate'].hasError('required') && absenceForm.get('absenceEndDate').touched">Bitiş tarihi
                            seçiniz</mat-error>
                        <mat-error *ngIf="absenceForm.controls['absenceEndDate'].hasError('notEquivalent')">Başlangıç tarihi bitiş tarihinden  büyük olamaz.</mat-error>
                    </div>
                </div>
        </div>-->

        <div class="row">
            <div class="col-lg-6" *ngIf="selectedAbsenceType != null && selectedAbsenceType.absenseTimeType == 'DAILY'"> <!--YILLIK IZIN SECILDI ISE-->
                <div class="form-group">
                    <mat-form-field class="w-100">
                        <input type="text" placeholder="Çalışma olmayan gün" aria-label="Number"
                            formControlName="freeDayAmount" [min]="0" matInput (change)="freeDayChange()">
                        <mat-error *ngIf="absenceForm.controls['freeDayAmount'].hasError('required')">Çalışma olmayan
                            gün giriniz</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-lg-6" >
                <div class="form-group">
                    <mat-form-field class="w-100">
                        <input type="text"
                               [placeholder]="(selectedAbsenceType != null && selectedAbsenceType.absenseTimeType === 'HOURLY') ? 'İzin süresi(saat)' : 'İzin süresi(gün)'"
                               aria-label="Number" formControlName="absenceDay" matInput readonly>
                        <mat-error *ngIf="absenceForm.controls['absenceDay'].value < 0.1">Çalışma
                            süresi 0 olamaz</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- baskasina ait bir kayit guncelleniyorsa data.employeeId ile currentUser.employeeId farkli demektir -->
            <!--<div class="col-lg-6" *ngIf="currentUser.manager && data.employeeId != currentUser.employeeId">-->
            <div class="col-lg-6" *ngIf="isAbsenceOwnerManager">
                <div class="form-group">
                  <mat-form-field style="width: 100%">
                    <input type="text" placeholder="Vekil Seçiniz" aria-label="Number" matInput
                           formControlName="proxyManagerId" [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                      <mat-option *ngFor="let manager of filteredManagerList | async" [value]="manager">
                        {{manager.name + " " + manager.surname}}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="absenceForm.controls['proxyManagerId'].hasError('required')">
                      Vekil Seçiniz
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
        </div>


        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="lookup-form-field" style="width: 100%;">
                        <textarea style="height: 100px;resize: none;" matInput formControlName="description"
                            id="description" class="form-control" aria-describedby="description" placeholder="Açıklama" maxlength="500"></textarea>
                    </mat-form-field>
                    <mat-error *ngIf="(absenceForm.get('absenceExcuseReason').value != null && absenceForm.get('absenceExcuseReason').value.id == 57) &&
                                      absenceForm.get('description').value == ''">
                        Açıklama girilmelidir
                    </mat-error>
                </div>
            </div>
        </div>

        <div class="form-group">
            <input type="file" #myFile placeholder="Dosya yükle" (change)="fileProgress($event)">
            <div  class="requiredFileOnClose" style="padding: 5px 4px; color: red"
                  *ngIf="selectedAbsenceType != null && selectedAbsenceType.requiredFileOnClose != null && fileList.length === 0">Lütfen {{selectedAbsenceType.requiredFileOnClose}} Yükleyiniz</div>

            <div *ngIf="fileUploadProgress">
                <span style="font-weight: bold;">Yükleniyor:</span> {{ fileUploadProgress }}
            </div>
            <div style="margin-top: 5px">
                <button class="btn btn-light" [disabled]="!fileData"  (click)="uploadFile()">Yükle</button>
            </div>
            <div style="margin-top: 5px" *ngFor="let file of fileList;let i = index;">
                <div class="filename-wrapper" *ngIf="!file.willBeDeleted">
                    <a style="width: 100px;max-width: 100px;">
                        {{file.fileName}}
                    </a>
                    <i class="material-icons icon" style="color: #c80000;margin-left: 5px;cursor: pointer" (click)="deleteFile(i)">
                        delete
                    </i>
                </div>
            </div>
        </div>

        <div>
            <mat-checkbox  formControlName="readAndAprroved" id="readAndAprroved" aria-label="description">
                <span (click)="openConditionsTemplate()" style="color: #0f87ff">İzin kural ve şartlarını</span> okudum, anladım.
            </mat-checkbox>
        </div>

        <button type="submit" class="btn btn-primary" (click)="createOrUpdateAbsence()"
                [disabled]="!absenceForm.valid ||
                            !absenceForm.get('readAndAprroved').value ||
                            (absenceForm.get('absenceExcuseReason').value != null &&
                             absenceForm.get('absenceExcuseReason').value.id == 57 &&
                             absenceForm.get('description').value == '')"
            >{{submitButtonName}}</button>
        <!--<button type="submit" class="btn btn-primary" (click)="createOrUpdateAbsence()">{{submitButtonName}}</button>-->
    </form>
</mat-dialog-content>


<ng-template #conditions>
    <div class="modal-header" style="height: 65px;">
        <h4 class="modal-title pull-left" style="font-size: 24px">İzin Kural ve Şartları</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="conditionModalRef.hide()">
            <span aria-hidden="true" style="font-size: 35px;">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="font-size: 13px;text-align: justify;overflow-y: scroll;">
        Görevlendirme yapılan veya izne ayrılan personel görev/izin esnasında, göreve/izne gidiş-dönüş esnasında
        iş sağlığı ve güvenliği kurallarına harfiyen uymakla yükümlüdür. Can ve mal güvenliği adına risk tespit ettiğinde
        durumu derhal yazılı olarak iş bu formu onaylayan birim yöneticisine bildirecektir. İş bu form onaylanmadan
        yerleşke dışına çıkacak personelin sorumluluğu kendisine aittir.

        <ul style="margin-left: -20px">
            <li> Talep edilen izin süresi hesabında ilgili giriş çıkış kayıtları esas alınacaktır.</li>
            <li>Vardiyalı çalışanlar için ilgili vardiya planı ek olarak yüklenmelidir. Beyan edilen vardiya düzenine
                göre çalışma günü olmayan gün sayısı hesaplanacaktır.</li>
            <li>Taşınma/görevlendirme/evlilik/vefat/doğum vb. izin türleri için gerekli ek dosyalar yüklenerek izin kaydı
                açılmalı veya İnsan Kaynakları birimine iletilmelidir.</li>
            <li>Yöneticiler için izin süresi boyunca başka bir “yönetici kullanıcı” vekil olarak seçilmelidir. İzin süresi
                boyunca açılan izin talepleri vekil olarak seçilen yöneticiye atanacaktır.</li>
            <li>Kişisel verilerin işlenmesinde başta özel hayatın gizliliği olmak üzere kişilerin temel hak ve özgürlüklerinin
                korunmasını amaçlayan 7 Nisan 2016 tarihli ve 29677 Sayılı Resmî Gazete’de yayımlanan 6698 sayılı Kişisel Verilerin
                Korunması Kanunu (“KVKK” veya “Kanun”)’nun “Veri Sorumlusunun Aydınlatma Yükümlülüğü” başlıklı 10. maddesi ile
                10 Mart 2018 tarih ve 30356 sayılı Resmi Gazete’de yayımlanan Aydınlatma Yükümlülüğünün Yerine Getirilmesinde
                Uyulacak Usul ve Esaslar Hakkında Tebliğ uyarınca gerekli şartlar ve tedbirler AKILLI BİNALAR TESİS YÖNETİM A.Ş.
                tarafından yerine getirilmekle beraber işlenen kişisel verileriniz hakkında bilgilendirme metni internet sitemiz
                <a href="http://www.akillibinalar.com.tr" target="_blank">www.akillibinalar.com.tr</a> adresinde yayınlanmaktadır.</li>
        </ul>
    </div>
</ng-template>
